import { render, staticRenderFns } from "./FooterAddress.vue?vue&type=template&id=3e1a5376"
import script from "./FooterAddress.vue?vue&type=script&lang=js"
export * from "./FooterAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports